import { PaymentModel } from './payment.model';

export class SizeModel {
  public size: number;

  constructor() {
    this.size = 0;
  }

  public isPresent(): boolean {
    return this.size != 0;
  }
}
